import { memo } from 'react'

import type {
  HeroCarouselItemBackgroundImageProps,
  HeroCarouselItemsProps,
} from '../hero-carousel'
import Background from './Background'
import Content from './Content'

const Slide = ({
  content,
  background,
  index,
  heroCarouselImages,
}: HeroCarouselItemsProps) => {
  const desktop = background.backgroundImages.find(
    (item: HeroCarouselItemBackgroundImageProps) =>
      item.device === '(min-width: 48em)'
  )

  const tablet = background.backgroundImages.find(
    (item: HeroCarouselItemBackgroundImageProps) =>
      item.device === '(min-width: 28.125em)'
  )

  const mobile = background.backgroundImages.find(
    (item: HeroCarouselItemBackgroundImageProps) =>
      item.device === '(max-width: 28.125em)'
  )

  return (
    <>
      <div className="hidden md:block">
        <Background
          heroCarouselImages={heroCarouselImages}
          url={desktop?.src}
          alignment={desktop?.alignContentHorizontally ?? ''}
          background={background}
          index={index}
        >
          <Content
            contentAlignment={desktop?.alignContentHorizontally ?? ''}
            textAlignment={desktop?.textAlign ?? 'center'}
            content={content}
          />
        </Background>
      </div>

      <div className="hidden sm:block md:hidden">
        <Background
          heroCarouselImages={heroCarouselImages}
          url={tablet?.src ?? ''}
          alignment={tablet?.alignContentHorizontally ?? ''}
          background={background}
          index={index}
        >
          <Content
            contentAlignment={tablet?.alignContentHorizontally ?? ''}
            textAlignment={tablet?.textAlign ?? 'center'}
            content={content}
          />
        </Background>
      </div>

      <div className="block w-full h-full sm:hidden">
        <Background
          heroCarouselImages={heroCarouselImages}
          url={mobile?.src ?? ''}
          alignment={mobile?.alignContentHorizontally ?? ''}
          background={background}
          index={index}
        >
          <Content
            contentAlignment={mobile?.alignContentHorizontally ?? ''}
            textAlignment={mobile?.textAlign ?? 'center'}
            content={content}
          />
        </Background>
      </div>
    </>
  )
}

export default memo(Slide)
